import { z } from 'zod';
/**
 * Reading level schema - indicates student's reading ability.
 * Word modes (ONE_WORD / SEVERAL_WORDS) drive the word-pick flow in the
 * assignment editor for early readers.
 */
export const ReadingLevelSchema = z.enum([
    'ONE_WORD',
    'SEVERAL_WORDS',
    'SINGLE_VERSE',
    'PASSAGE',
]);
/**
 * Writing level schema - indicates student's writing ability
 */
export const WritingLevelSchema = z.enum([
    'NONE',
    'ONE_WORD',
    'SEVERAL_WORDS',
    'SENTENCES',
]);
/** Select options — the schemas are the single source for every <select> */
export const READING_LEVELS = ReadingLevelSchema.options;
export const WRITING_LEVELS = WritingLevelSchema.options;
/** Word modes get the tappable word-pick editor instead of verse ranges */
export function isWordLevel(level) {
    return level === 'ONE_WORD' || level === 'SEVERAL_WORDS';
}
/** A student who needs no stepped-down assignment reads & writes fully */
export const FULL_READING_LEVEL = 'PASSAGE';
export const FULL_WRITING_LEVEL = 'SENTENCES';
/** Sensible starting point when a student is marked learning to read & write */
export const LEARNING_READING_LEVEL = 'ONE_WORD';
export const LEARNING_WRITING_LEVEL = 'NONE';
/** True when the student's levels are stepped down from the full assignment —
 *  drives the "Learning to read & write" toggle in the configurators */
export function isLearningLevels(reading, writing) {
    return reading !== FULL_READING_LEVEL || writing !== FULL_WRITING_LEVEL;
}
/**
 * Display-friendly text for reading levels.
 * Falls back to the raw value — stored records are loaded without Zod
 * validation, so unknown/legacy values can reach the UI.
 */
export function readingLevelToDisplayText(level) {
    const displayMap = {
        ONE_WORD: 'One word',
        SEVERAL_WORDS: 'Several words',
        SINGLE_VERSE: 'Single verse',
        PASSAGE: 'Passage',
    };
    return displayMap[level] ?? level;
}
/**
 * Display-friendly text for writing levels
 */
export function writingLevelToDisplayText(level) {
    const displayMap = {
        NONE: 'None',
        ONE_WORD: 'One word',
        SEVERAL_WORDS: 'Several words',
        SENTENCES: 'Sentences',
    };
    return displayMap[level] ?? level;
}
//# sourceMappingURL=reading-levels.js.map